import { knownErrors } from '../constants/errors';
export const isKnownError = (message, status) => knownErrors.some(item => item.status === status && message.includes(item.message));